import * as React from 'react';

import PartnerList from 'bundles/browse-common/components/PartnerList';
import { getPartnerData } from 'bundles/browse-common/utils/experimentUtils';

const TopPartnersComponentRenderer = () => {
  const partnerData = getPartnerData();
  return <PartnerList partners={partnerData} />;
};

export default TopPartnersComponentRenderer;
